<template>
<div  class="notifications">
    <div  v-for="(notice,n) in notifications" :key="'notify'+n" :ref="'E'+n" @click="closeN(notice,n)" :style="'position:absolute;opacity:0.9;top:'+(noticePos(n)+topPad)+'px'">
       <notify @closePopUp="closeN(notice,n)" v-if="!notice.closed" :notice="notice" ></notify>
    </div>
   <div v-if="false && showHelpIcon" style="top: 20px;right: 10px;" class="helpIcon" @click="showHelp"></div>
  </div>
</template>

<script>
import gsap from 'gsap'
import notify from '@/components/notify'
export default {
  components: {
   notify
  },
  props: {
   
  },
  data() {
    return {
      topPad:25,
      noticeHeight:75,
      help1:null,
      help2:null,
    };
  },
  mounted(){
   
  },
  computed: {
    notifications(){
      return this.$store.getters.getNotifications
    },
    showHelpIcon(){
      let showHelp=true
      for(var i=this.notifications.length;i>0;i--){
        if(!this.notifications[i-1].closed && !this.notifications[i-1].hideSearch){
        //if(!this.notifications[i-1].closed && !this.notifications[i-1].hideSearch){
          showHelp=false
        }
      }
      return showHelp
    }
  },
  methods: {
    async getHelp(helpID,helpName){
				 await this.$store.dispatch("retreiveText",{type:"Help",element:helpID})
				
				 this[helpName]=this.$store.getters.getTextElement({collection:"Help",doc:helpID})
				  
      },
      showHelpX(){
        this.$store.dispatch("showNextHelp",this.$store.getters.getNextHelp)
        this.$store.dispatch("nextHelp")
			},
     noticePos(n){
     let top=0
     for(var i=this.notifications.length;i>n+1;i--){
      if(!this.notifications[i-1].closed && !this.notifications[i-1].hideSearch){
        top+=this.noticeHeight
      }
     }
     return top
   },
  
  
   closeN(notice,index){
    let self=this
     //gsap.to(this.$refs["E"+index],1,{height:0})
     
     gsap.delayedCall(1,function(){
       self.$set(notice,"closed",true)
     })
     gsap.to(this.$refs["E"+index],1,{autoAlpha:0})
   },
   removeNotice(){
      this.$set(notice,"closed",true)
   }
  },
  watch:{
    showHelpIcon(val){
      this.$store.commit("setShowHelpIcon",val)
    }
  }
};
</script>

<style lang="scss" scoped>
 @import "@/assets/sass/variables.scss";
//$border-blue:#00bbff;
.notifications{
  width: 440px;
   position:absolute;
   top:0px;
   right:0px;
   display: table-cell;
  vertical-align: bottom;
}
.refPad{
  height:0px;
  width:400px;
}



</style>
